var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "task-remove",
    transform: "translate(-7.5 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13384",
    "data-name": "Path 13384",
    d: "M34.615,33.571,37.2,31.007,36.185,30,33.6,32.564,31.015,30,30,31.007l2.585,2.564L30,36.136l1.015,1.007L33.6,34.579l2.585,2.564L37.2,36.136Z",
    transform: "translate(-11.7 -14.143)",
    fill: "#868a97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13385",
    "data-name": "Path 13385",
    d: "M21.9,5.143H19.74V4.429A1.439,1.439,0,0,0,18.3,3H12.54A1.439,1.439,0,0,0,11.1,4.429v.714H8.94A1.439,1.439,0,0,0,7.5,6.571v15A1.439,1.439,0,0,0,8.94,23h6.48V21.571H8.94v-15H11.1V8.714h8.64V6.571H21.9v7.143h1.44V6.571A1.439,1.439,0,0,0,21.9,5.143ZM18.3,7.286H12.54V4.429H18.3Z",
    fill: "#868a97"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskFailed);
export default __webpack_public_path__ + "static/media/taskFailed.2f02777426e211eba152a7f25d6fa612.svg";
export { ForwardRef as ReactComponent };